'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: ', ';\n    width: 100%;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: ', ';\n    width: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _script = require('../../hocs/script');

var _script2 = _interopRequireDefault(_script);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MapContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var isMobile = _ref.isMobile;
    return isMobile ? '250px' : '350px';
});

var MapviewDynamic = function MapviewDynamic(_ref2) {
    var mobile = _ref2.mobile,
        address = _ref2.address,
        context = _ref2.context,
        intl = _ref2.intl;

    var mapRef = (0, _react.useRef)();

    (0, _react.useEffect)(function () {
        if (window.google && address && address.location && address.location.longitude && address.location.latitude) {
            var mapOptions = {
                center: {
                    lat: parseFloat(address.location.latitude),
                    lng: parseFloat(address.location.longitude)
                },
                zoom: 14,
                streetViewControl: false,
                zoomControl: false,
                panControl: true,
                fullscreenControl: false,
                clickableIcons: false,
                mapTypeControl: false
            };

            var map = new window.google.maps.Map(mapRef.current, mapOptions);

            var marker = new window.google.maps.Marker({
                position: mapOptions.center,
                map: map
            });

            // Create a div to hold the control.
            var controlDiv = document.createElement('div');

            // Set CSS for the control border.
            var controlUI = document.createElement('div');
            controlUI.style.backgroundColor = '#fff';
            controlUI.style.border = '2px solid #fff';
            controlUI.style.borderRadius = '3px';
            controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
            controlUI.style.cursor = 'pointer';
            controlUI.style.marginBottom = '22px';
            controlUI.style.textAlign = 'center';
            controlUI.title = intl.formatMessage({ id: 'MapviewDynamic.centerMap' });
            controlDiv.appendChild(controlUI);

            var controlText = document.createElement('div');
            controlText.style.color = 'rgb(25,25,25)';
            controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
            controlText.style.fontSize = '16px';
            controlText.style.lineHeight = '38px';
            controlText.style.paddingLeft = '5px';
            controlText.style.paddingRight = '5px';
            controlText.innerHTML = intl.formatMessage({ id: 'MapviewDynamic.centerMap' });
            controlUI.appendChild(controlText);

            controlUI.addEventListener('click', function () {
                return map.setCenter(marker.getPosition());
            });

            map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(controlDiv);
        }
    }, [address, context, intl]);

    var addressErrorMessage = intl.formatMessage({ id: 'MapviewDynamic.addressError' });

    return _react2.default.createElement(
        MapContainer,
        {
            id: 'MapView',
            isMobile: mobile,
            ref: mapRef },
        !address || !address.location || !address.location.longitude || !address.location.latitude ? _react2.default.createElement(_label2.default, { text: addressErrorMessage, warning: true }) : null
    );
};

MapviewDynamic.propTypes = {
    mobile: _propTypes2.default.bool.isRequired,
    address: _propTypes2.default.object.isRequired,
    context: _propTypes2.default.object.isRequired,
    intl: _propTypes2.default.object.isRequired
};

var MapviewDynamicWithIntl = (0, _reactIntl.injectIntl)(MapviewDynamic);
var WrappedMapviewDynamic = (0, _script2.default)(MapviewDynamicWithIntl, 'gMaps', 'https://maps.googleapis.com/maps/api/js?libraries=places&key=@&gMaps&@');

exports.default = WrappedMapviewDynamic;